import React, { type FC } from "react";

const Loader: FC = () => (
  <div
    className="loader"
    aria-label="Loading..."
    role="status"
    aria-busy="true"
  ></div>
);

export { Loader };
